import React from 'react'
import Select from 'react-select';
import ColorPicker from './ColorPicker.js';


class BorderPicker extends React.Component {
    constructor(props) {
        super(props);

        this.changeWidth = this.changeWidth.bind(this);
        this.changeType = this.changeType.bind(this);
        this.output = this.output.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.defaultState = this.defaultState.bind(this);

        this.defaultState(props);

        
    }

    defaultState(props) {
        this.state = {
            color:'#000000',
            width:0,
            type:'none',
            timestamp:new Date().getMilliseconds()      
        };

        if(props.data != 'none') {
            let data = []; 
            if(props.format == true) {
                data = props.data.split(' ');
            }else{
                data = props.data.split('|');
            }

            this.state = {
                color:data[2],
                width:data[0].replace('px',''),
                type:data[1]      
            };
        }
    }

    output() {
        let change = this.state.width+'px|'+this.state.type+'|'+this.state.color;

        if(this.props.format === true) {
            change = this.state.width+'px '+this.state.type+' '+this.state.color;
        }       
        

        this.props.handleBorderChange(this.props.id,change);
    }

    changeType(val){
        this.setState({type:val.value,timestamp:new Date().getMilliseconds()});
    };

    handleColorChange(key,color) {
        this.setState({color:color,timestamp:new Date().getMilliseconds()});
    }

    renderLabel(key,name) {
        return(
            <div className="picker-value">
                <div className="picker-preview">
                    <div className={`pre ${key}`}>&nbsp;</div>
                </div>
                <div className="picker-description">
                    {name}
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }

    changeWidth(e) {
        let val = e.target.value.replace(/[^0-9.]+/g, "");

        this.setState({width:val,timestamp:new Date().getMilliseconds()});
    }

    componentWillReceiveProps(nextProps) {
        this.defaultState(nextProps);
    }

    componentDidUpdate(prevObject, prevState) {
        if(this.state.timestamp != prevState.timestamp) {
            this.output();
        }
    }

    render() {
        let options = [
            { value: 'none',clearableValue:false, label: this.renderLabel('none','None') },
            { value: 'solid',clearableValue:false, label: this.renderLabel('solid','Solid') },
            { value: 'dashed',clearableValue:false, label: this.renderLabel('dashed','Dashed') },
            { value: 'dotted',clearableValue:false, label: this.renderLabel('dotted','Dotted') }
        ];


        return (
            <div className="col-sm-12 p-0">
                <div className="col-sm-5 p-0">
                    <Select
                        allowCreate={false}
                        searchable={false}
                        clearable={false}
                        name="form-field-name"
                        value={this.state.type}
                        options={options}
                        onChange={this.changeType}
                    />
                </div>
                <div className="col-sm-5">
                    <div className="input-group">
                        <input type="text" className="form-control" value={this.state.width} onChange={this.changeWidth} placeholder="Border width" />
                        <span className="input-group-addon">px</span>
                    </div>
                </div>
                <div className="col-sm-2">
                    <ColorPicker id='innerBackgroundColor' color={this.state.color} handleColorChange={this.handleColorChange} />
                </div>
            </div>
        );
    }

  
}

export default BorderPicker;




// WEBPACK FOOTER //
// ./components/builder/BorderPicker.js